module.exports = __webpack_public_path__ + "public/img/ico-charts-toGrid.f3d8767f.svg";